import React from 'react';
import OurSpeciality from '../components/SpecialityElements/OurSpeciality';
import SpecialityItem from '../components/SpecialityElements/SpecialityItem';

const SpecialityContainer = () => {
    const SpecialityData = [
        {
            id: '1',
            heading: 'Finest Chef',
            icon: 'images/about/icon1.png',
            bg: 'images/about/7.jpg',
            description: 'Lorem ipsum dolor sit amet elit consectetur adipiscing condem incididu ut labore et dolore magna aliqua. ad minim veniam',
        },
        {
            id: '2',
            heading: 'Beautiful Ambience',
            icon: 'images/about/icon2.png',
            bg: 'images/about/8.jpg',
            description: 'Lorem ipsum dolor sit amet elit consectetur adipiscing condem incididu ut labore et dolore magna aliqua. ad minim veniam',
        },
        {
            id: '3',
            heading: 'Sea Food Takeout',
            icon: 'images/about/icon3.png',
            bg: 'images/about/9.jpg',
            description: 'Lorem ipsum dolor sit amet elit consectetur adipiscing condem incididu ut labore et dolore magna aliqua. ad minim veniam',
        },
        {
            id: '4',
            heading: 'Famous Cuisines',
            icon: 'images/about/icon4.png',
            bg: 'images/about/10.jpg',
            description: 'Lorem ipsum dolor sit amet elit consectetur adipiscing condem incididu ut labore et dolore magna aliqua. ad minim veniam',
        },
    ];


    return (
        <div className="section speciality bg_image_9">
            <div className="container">
                <div className="row">
                    <div className="col-lg-7 col-md-7">
                        <div className="speciality_square">
                            {
                                SpecialityData.map(data => <SpecialityItem
                                    key={data.id}
                                    data={data}
                                />)
                            }
                        </div>
                    </div>

                    <OurSpeciality />
                </div>
            </div>
        </div >
    );
};

export default SpecialityContainer;